export const mortgageNav = {
  "header": {
    "main_navigation": [
      {
        "url": "/mortgage/loan-types",
        "label": "Loan Types"
      },
      {
        "url": "/mortgage/loan-process",
        "label": "Loan Process"
      },
      {
        "url": "/mortgage/meet-the-mortgage-team",
        "label": "Meet The Team"
      },
      {
        "url": "/mortgage/refinance",
        "label": "Refinance"
      },
      {
        "url": "/mortgage/mortgage-resources",
        "label": "Resources"
      }
    ],
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/1Ur7a0bVrKcgUG6fgoF4ug/c955a37ce090a61f2cf8d6c2125480c3/MortgageColorHorizontal_1024.png",
      "width": 1024,
      "height": 226
    }
  },
  "footer": {
    "menuLinks": [
      {
        "url": "/mortgage/loan-types",
        "label": "Loan Types"
      },
      {
        "url": "/mortgage/loan-process",
        "label": "Loan Process"
      },
      {
        "url": "/mortgage/meet-the-team",
        "label": "Meet the Team"
      },
      {
        "url": "/mortgage/refinance",
        "label": "Refinance"
      },
      {
        "url": "/about",
        "label": "About Sibcy Cline"
      }
    ],
    "legalLinks": [
      {
        "url": "/mortgage/legal",
        "label": "Privacy, Security & Legal"
      },
      {
        "url": "https://static1.sibcycline.com/mediafiles/pdf/scms/rovrequestform.pdf",
        "label": "Request for ROV form"
      }
    ],
    "rightImage": {
      "url": "/mortgage",
      "image": {
        "src": "https://static1.sibcycline.com/logos/EqualLending/LendingWhite.png",
        "width": "88px",
        "height": "85px"
      }
    },
    "copyrightText": "Sibcy Cline Mortgage Services, Inc. — License: NMLS #140211/OH: RM.850050.000 ",
    "description": {
      "json": {
        "nodeType": "document",
        "data": {},
        "content": [
          {
            "nodeType": "paragraph",
            "data": {},
            "content": [
              {
                "nodeType": "text",
                "value": "8044 Montgomery Rd Suite 301 \nCincinnati, Ohio 45236 \n513-984-6776 | 888-984-6776 ",
                "marks": [],
                "data": {}
              }
            ]
          },
          {
            "nodeType": "paragraph",
            "data": {},
            "content": [
              {
                "nodeType": "text",
                "value": "Equal Housing Lender. All loans subject to credit approval.",
                "marks": [
                  {
                    "type": "italic"
                  }
                ],
                "data": {}
              },
              {
                "nodeType": "text",
                "value": " ",
                "marks": [],
                "data": {}
              }
            ]
          }
        ]
      }
    },
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/3rD9Bi1pbGAutzkqg5YeTl/6b8e8da56f7c3a1e48b7610e6970e893/Sibcy-white-horizontal__MortgageFnl.png",
      "width": 2933,
      "height": 647
    }
  }
};
export const mainNav = {
  "header": {
    "my_account": {
      "label": "My account",
      "subLinks": [
        {
          "children": [
            {
              "url": "/account/liked",
              "label": "Liked"
            },
            {
              "url": "/account/searches",
              "label": "Searches"
            },
            {
              "url": "/account/notes",
              "label": "Notes"
            },
            {
              "url": "/account/notifications",
              "label": "Notifications"
            },
            {
              "url": "/account",
              "label": "Settings"
            },
            {
              "url": "/auth/logout",
              "label": "Logout"
            }
          ]
        }
      ]
    },
    "main_navigation": [
      {
        "label": "Buy",
        "subLinks": [
          {
            "heading": "Browse",
            "children": [
              {
                "url": "/browse?search_type=all_listings",
                "label": "Browse A-Z",
                "forceAnchorTag": true
              },
              {
                "url": "/coming-soon",
                "label": "Coming Soon"
              },
              {
                "url": "/browse",
                "label": "New Listings",
                "forceAnchorTag": true
              },
              {
                "url": "/browse?search_type=price_changes",
                "label": "Price Changes",
                "forceAnchorTag": true
              },
              {
                "url": "/browse?search_type=open_houses",
                "label": "Open Houses",
                "forceAnchorTag": true
              },
              {
                "url": "/browse?search_type=new_construction",
                "label": "New Construction",
                "forceAnchorTag": true
              },
              {
                "url": "/builder",
                "label": "Premier Builders"
              },
              {
                "url": "https://www.leadingre.com/?coid=7884",
                "label": "National Search"
              },
              {
                "url": "/results?status=Active&status=Pending",
                "label": "View All Properties",
                "forceAnchorTag": true
              }
            ]
          },
          {
            "heading": "Premier Collection",
            "children": [
              {
                "url": "/premier-collection",
                "label": "Luxury Homes"
              },
              {
                "url": "/builder",
                "label": "Find a Builder"
              },
              {
                "url": "/development",
                "label": "Explore Developments"
              }
            ]
          },
          {
            "heading": "Get Help",
            "children": [
              {
                "url": "https://applymortgage.sibcycline.com/#/milestones",
                "label": "Get Pre-Approved"
              },
              {
                "url": "/guidance/buyer-guide",
                "label": "Buyer’s Guide"
              },
              {
                "url": "/find-an-agent",
                "label": "Find an Agent"
              }
            ]
          }
        ]
      },
      {
        "label": "Sell",
        "subLinks": [
          {
            "children": [
              {
                "url": "/sell-your-home",
                "label": "Sell your Home"
              },
              {
                "url": "/guidance/seller-guide",
                "label": "Seller’s Guide"
              },
              {
                "url": "/find-an-agent",
                "label": "Find an Agent"
              },
              {
                "url": "/home-services",
                "label": "Home Services"
              }
            ]
          }
        ]
      },
      {
        "label": "Guidance",
        "subLinks": [
          {
            "children": [
              {
                "url": "/schools",
                "label": "School Links"
              },
              {
                "url": "/community",
                "label": "Community Guide"
              },
              {
                "url": "/guidance/buyer-guide",
                "label": "Buyer’s Guide"
              },
              {
                "url": "/guidance/seller-guide",
                "label": "Seller’s Guide"
              },
              {
                "url": "/guidance/regions",
                "label": "Regional Guide"
              },
              {
                "url": "/sell-your-home",
                "label": "What's Your Home Worth?"
              },
              {
                "url": "/guidance/utility-connection",
                "label": "Utility Connection"
              },
              {
                "url": "/blog",
                "label": "Blog"
              }
            ]
          }
        ]
      },
      {
        "label": "Services",
        "subLinks": [
          {
            "children": [
              {
                "url": "/services",
                "label": "Overview"
              },
              {
                "url": "/mortgage",
                "label": "Mortgage"
              },
              {
                "url": "https://insurance.sibcycline.com/",
                "label": "Insurance"
              },
              {
                "url": "https://title.sibcycline.com/",
                "label": "Title"
              },
              {
                "url": "/relocation",
                "label": "Relocation"
              },
              {
                "url": "/programs/military-on-the-move",
                "label": "U.S. Military on the Move"
              },
              {
                "url": "/home-services",
                "label": "Home Services"
              },
              {
                "url": "/programs/home-warranty",
                "label": "Home Warranty"
              },
              {
                "url": "/programs/quickbuy",
                "label": "QuickBuy Cash Offers"
              },
              {
                "url": "/earnest",
                "label": "Earnest Money Payment"
              }
            ]
          }
        ]
      },
      {
        "label": "Agents",
        "subLinks": [
          {
            "children": [
              {
                "url": "/offices",
                "label": "Offices"
              },
              {
                "url": "/find-an-agent",
                "label": "Find an Agent"
              },
              {
                "url": "https://joinsibcycline.com/",
                "label": "Becoming an Agent"
              }
            ]
          }
        ]
      }
    ],
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/6zn4KuBh31VDdj5UgAoeOs/964edb516df6e5d6ce3d5f1c9137c036/icons-logos-sibcy-horizontal-white.svg",
      "width": 230,
      "height": 51
    }
  },
  "footer": {
    "menuLinks": [
      {
        "url": "/about",
        "label": "About us"
      },
      {
        "url": "/careers",
        "label": "Careers"
      },
      {
        "url": "/find-an-agent",
        "label": "Find an agent"
      },
      {
        "url": "/contact",
        "label": "Contact us"
      }
    ],
    "legalLinks": [
      {
        "url": "/about/privacy",
        "label": "Privacy"
      },
      {
        "url": "/about/accessibility",
        "label": "Accessibility"
      },
      {
        "url": "/about/terms-of-use",
        "label": "Notices"
      }
    ],
    "rightImage": {
      "url": "https://www.leadingre.com/?coid=7884",
      "image": {
        "src": "/images/logos/logo-lrecotw-white@3x.png",
        "width": "77px",
        "height": "60px"
      }
    },
    "copyrightText": "Sibcy Cline, Inc. All rights reserved. All Information is believed accurate, but is NOT guaranteed.",
    "description": {
      "json": {
        "data": {},
        "content": [
          {
            "data": {},
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "Sibcy Cline proudly offers real estate services in Cincinnati Ohio, Northern Kentucky, Dayton Ohio and Southeast Indiana. We're one of the largest local, independent, and family-owned brokerages in the region.",
                "nodeType": "text"
              }
            ],
            "nodeType": "paragraph"
          }
        ],
        "nodeType": "document"
      }
    },
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/6zn4KuBh31VDdj5UgAoeOs/964edb516df6e5d6ce3d5f1c9137c036/icons-logos-sibcy-horizontal-white.svg",
      "width": 230,
      "height": 51
    }
  }
};
export const insuranceNav = {
  "header": {
    "main_navigation": [
      {
        "url": "/insurance/insurance-types",
        "label": "Insurance Types"
      },
      {
        "url": "/insurance/meet-the-team",
        "label": "Meet the Team"
      },
      {
        "url": "/insurance/guide",
        "label": "Guide"
      },
      {
        "url": "/insurance/claims",
        "label": "Claims"
      },
      {
        "url": "/insurance/resources",
        "label": "Resources"
      }
    ],
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/62n9UJQqqqweKgW5ukcLaZ/5c74a4ca3af25ed87aaeba3c9aee2ebe/ForDigital_RGB_Sibcy-color-horizontal__InsuranceFnl.png",
      "width": 3300,
      "height": 899
    }
  }
};
export const homeServicesNav = {
  "footer": {
    "menuLinks": [
      {
        "url": "tel:5139859565",
        "label": "513-985-9565"
      },
      {
        "url": "tel:8889699944",
        "label": "888-969-9944"
      }
    ],
    "legalLinks": [
      {
        "url": "/about/privacy",
        "label": "Privacy"
      },
      {
        "url": "/about/accessibility",
        "label": "Accessibility"
      },
      {
        "url": "/about/terms-of-use",
        "label": "Notices"
      }
    ],
    "rightImage": {
      "url": "https://www.leadingre.com/?coid=7884",
      "image": {
        "src": "/images/logos/logo-lrecotw-white@3x.png",
        "width": "77px",
        "height": "60px"
      }
    },
    "copyrightText": "Sibcy Cline, Inc. All rights reserved. All Information is believed accurate, but is NOT guaranteed. Serving Greater Cincinnati, Greater Dayton, Northern Kentucky and Southeast Indiana",
    "description": {
      "json": {
        "data": {},
        "content": [
          {
            "data": {},
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "We know how challenging it can be to find dependable professionals when you have maintenance, repairs or remodeling needs. Sibcy Cline Home Services is there to help by connecting you to reliable services and vendors.",
                "nodeType": "text"
              }
            ],
            "nodeType": "paragraph"
          }
        ],
        "nodeType": "document"
      }
    },
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/4QFhBOTJHxV6DTyTWMh4SP/0f4884449e4f73eb53219a862f084efe/homeservices-white-logo.png",
      "width": 200,
      "height": 44
    }
  },
  "header": {
    "main_navigation": [
      {
        "url": "tel:5139859565",
        "label": "513-985-9565"
      },
      {
        "url": "tel:8889699944",
        "label": "888-969-9944"
      }
    ],
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/3cYb8dquI3sf0YZUKtJjiR/7c8a8f3763629cd5b44eeb6d3968ce30/homeservices-color-logo.png",
      "width": 480,
      "height": 106
    }
  }
};
export const relocationNav = {
  "footer": {
    "menuLinks": [
      {
        "url": "/relocation/corporate-relocations",
        "label": "Corporate Relocations"
      },
      {
        "url": "/relocation/meet-the-team",
        "label": "Meet the Team"
      },
      {
        "url": "/relocation/referrals",
        "label": "Referrals"
      },
      {
        "url": "/relocation/resources",
        "label": "Resources"
      },
      {
        "url": "/about",
        "label": "About Sibcy Cline"
      }
    ],
    "legalLinks": [
      {
        "url": "/about/privacy",
        "label": "Privacy"
      },
      {
        "url": "/about/accessibility",
        "label": "Accessibility"
      },
      {
        "url": "/about/terms-of-use",
        "label": "Notices"
      }
    ],
    "rightImage": {
      "url": "https://www.leadingre.com/?coid=7884",
      "image": {
        "src": "/images/logos/logo-lrecotw-white@3x.png",
        "width": "77px",
        "height": "60px"
      }
    },
    "copyrightText": "Sibcy Cline Relocation Services, Inc.",
    "socialLinks": [
      {
        "icon": "x",
        "url": "https://x.com/sibcycline"
      },
      {
        "icon": "facebook",
        "url": "https://www.facebook.com/SibcyClineRealtors"
      },
      {
        "icon": "instagram",
        "url": "https://www.instagram.com/sibcycline"
      },
      {
        "icon": "linkedin",
        "url": "https://www.linkedin.com/company/sibcy-cline-relocation-services-inc-"
      }
    ],
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/QJZfLLGPLB1iFfc8CUP5H/3492e6d41a02940c4d6aa606bac1f7ec/relocation-white-logo.png",
      "width": 480,
      "height": 106
    }
  },
  "header": {
    "main_navigation": [
      {
        "url": "/relocation/corporate-relocations",
        "label": "Corporate Relocations"
      },
      {
        "url": "/relocation/meet-the-team",
        "label": "Meet the Team"
      },
      {
        "url": "/relocation/referrals",
        "label": "Referrals"
      },
      {
        "url": "/relocation/resources",
        "label": "Resources"
      },
      {
        "url": "tel:1-800-321-3403",
        "label": "800-321-3403"
      }
    ],
    "logo": {
      "url": "https://images.ctfassets.net/wzzep3ntdgx4/6fqWkltm0EZJxGIE9ozRty/3083649d6fa931c937c82cd1103d1255/relocation-color-logo.png",
      "width": 480,
      "height": 106
    }
  }
};
